export const REPORTS = 'REPORTS';
export const ACCESS_RIGHTS = 'ACCESS_RIGHTS';
